import { createAsyncThunk } from '@reduxjs/toolkit';
import payrollServiceApiInstance from '../../../../../config/payrollApiConfig';
import { ExpenseCategory } from './expensesCategoriesTypes';

// Create
export const createCategory = createAsyncThunk(
  'expensesCategories/create',
  async (data: any, { rejectWithValue }) => {
    try {
      const res = await payrollServiceApiInstance.post('/expense-categories', data);
      return res.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to create expense category');
    }
  }
);

// Get All
export const fetchAllCategories = createAsyncThunk(
  'expensesCategories/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const res = await payrollServiceApiInstance.get('/expense-categories');
      return res.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch categories');
    }
  }
);

// Get By ID
export const fetchCategoryById = createAsyncThunk(
  'expensesCategories/fetchById',
  async (id: number, { rejectWithValue }) => {
    try {
      const res = await payrollServiceApiInstance.get(`/expense-categories/${id}`);
      return res.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch category');
    }
  }
);

// Update
export const updateCategory = createAsyncThunk(
  'expensesCategories/update',
  async ({ id, data }: { id: number; data: any }, { rejectWithValue }) => {
    try {
      await payrollServiceApiInstance.put(`/expense-categories/${id}`, data);
      return { id, data };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to update category');
    }
  }
);

// Delete
export const deleteCategory = createAsyncThunk(
  'expensesCategories/delete',
  async (id: number, { rejectWithValue }) => {
    try {
      await payrollServiceApiInstance.delete(`/expense-categories/${id}`);
      return id;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to delete category');
    }
  }
);
